import { render, staticRenderFns } from "./DetailedConfirmModal.vue?vue&type=template&id=fae4e29e&scoped=true&"
import script from "./DetailedConfirmModal.vue?vue&type=script&lang=ts&"
export * from "./DetailedConfirmModal.vue?vue&type=script&lang=ts&"
import style0 from "./DetailedConfirmModal.vue?vue&type=style&index=0&id=fae4e29e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae4e29e",
  null
  
)

export default component.exports